
































































import { Component, Vue } from "vue-property-decorator";
import TransferRegion from "@/store/entities/transferRegion";
import Ajax from '../../../../lib/ajax';

@Component({})

export default class AddTransferRegion extends Vue {
  isValid: boolean = false;
  dialog: boolean = true;
  transferRegion: TransferRegion = new TransferRegion();


  data() {
    return {
      title: "Preliminary report",
      email: "",
      rules: {
        required: (value) => !!value || "Zorunlu Alan.",
      },
    };
  }

  created() {
  }

  async saveRegion() {
  await Ajax.post(
        '/api/services/app/Transfer/SaveRegion',this.transferRegion
      );

      Vue.$toast.success("Kayıt Eklendi");
      this.closeDialog();


   
  }


  closeDialog() {
    this.$emit("closed");
  }

  cancelDialog() {
    this.$emit("cancel");
  }
}
